<template>
  <PageVC class="booking booking-preorder-intro">
    <div class="a-container">
      <h1 class="a-page-title">Bestil sammen</h1>
      <div class="booking-preorder-intro__teaser-text a-rich-text a-rich-text--centered">
        <p>Send linket til de andre gæster, så de kan vælge på deres egen telefon.</p>
      </div>
      <HUILoadingView v-if="!booking || !order || !entered || !menu" />
      <template v-else>
        <div class="booking-preorder-intro__multiplayer">
          <BookingPreorderShare :order-lines="orderLines"></BookingPreorderShare>
        </div>
        <RouterButton
          theme="green"
          :to="{ name: routes.BOOKING_PREORDER_MENU, params: { bookingToken: $route.params.bookingToken } }"
        >Fortsæt til forudbestilling</RouterButton>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { HUILoadingView, HUILegendWithBullets } from '@/halifax-ui'
import BookingPreorderBase from '@/views/BookingPreorderBase'
import PageVC from '@/containers/PageVC'
import RouterButton from '@/containers/RouterButton'
import BookingPreorderShare from '@/containers/BookingPreorderShare'

export default {
  extends: BookingPreorderBase,
  components: {
    PageVC,
    HUILoadingView,
    RouterButton,
    BookingPreorderShare
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.booking-preorder-intro {
  $module: '.booking-preorder-intro';

  &__multiplayer {
    margin-bottom: 45px;
  }
  &__teaser-text {
    margin-top: -25px;
    margin-bottom: 20px;
  }
}
</style>
